// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"234":"b0f66c49","318":"317acc3b","828":"417a921d"}[chunkId] + ".css";
};